<template>
  <Section class="black--text py-6" style="height: 100%; overflow-x: hidden;">
    <v-icon size="96" color="primary">mdi-check-circle-outline</v-icon>      

    <h1 class="text-center pt-4">Your request was sent.</h1>
    <div class="pt-6">
      Thanks for reaching out.  We may take up to a week to process your request.  Thank you for your patience.
    </div>

    <div class="d-flex justify-center pt-12">
      <v-btn color="primary" @click="continueClick">Continue</v-btn>
    </div>
  </Section>
</template>

<script>

import { Section } from '@/components/pages'

export default {
  name: 'HistoryDisputeConfirm',

  components: { Section },

  methods: {
    continueClick() {
      // this.$router.back()
      this.$router.replace({ name: 'billing/history' })
    }
  }
}
</script>